import { Phone, MapPin } from "lucide-react";
import { CLINIC } from "../../data/content";
import { scrollToId } from "../../lib/scroll";

const quickLinks = [
    { label: "Home", href: "#home" },
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Appointment", href: "#appointment" },
    { label: "Contact", href: "#contact" },
];

export const Footer = () => (
    <footer data-testid="footer" className="border-t border-white/10 bg-ink pb-10 pt-16 text-[#f8f6f0]">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 md:grid-cols-3 lg:px-10">
            <div>
                <p className="font-display text-2xl">
                    Smile <em className="text-teal-300">Dental</em> Clinic
                </p>
                <p className="mt-4 flex max-w-xs items-start gap-3 text-sm leading-relaxed text-slate-300">
                    <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-teal-300" />
                    <span data-testid="footer-address">{CLINIC.addressLines.join(" ")}</span>
                </p>
                <a
                    data-testid="footer-phone"
                    href={`tel:${CLINIC.phoneTel}`}
                    className="mt-3 inline-flex items-center gap-3 text-sm font-bold text-slate-200 transition-colors hover:text-teal-300"
                >
                    <Phone className="h-4 w-4 text-teal-300" /> {CLINIC.phoneDisplay}
                </a>
            </div>
            <div>
                <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-teal-300">Quick Links</p>
                <ul className="mt-5 space-y-3">
                    {quickLinks.map((l) => (
                        <li key={l.href}>
                            <button
                                data-testid={`footer-link-${l.label.toLowerCase()}`}
                                onClick={() => scrollToId(l.href)}
                                className="text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300"
                            >
                                {l.label}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <p className="text-xs font-extrabold uppercase tracking-[0.25em] text-teal-300">Legal</p>
                <ul className="mt-5 space-y-3">
                    <li>
                        <a data-testid="footer-privacy-link" href="#" className="text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300">
                            Privacy Policy
                        </a>
                    </li>
                    <li>
                        <a data-testid="footer-terms-link" href="#" className="text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300">
                            Terms
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div className="mx-auto mt-14 max-w-7xl border-t border-white/10 px-5 pt-6 lg:px-10">
            <p data-testid="footer-copyright" className="text-center text-xs font-semibold text-slate-400">
                © 2026 Smile Dental Clinic. All rights reserved.
            </p>
        </div>
    </footer>
);
